import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Warehouse } from 'src/typings';
import { WarehouseService } from '../warehouse.service';

@Component({
  selector: 'app-warehouse-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent implements OnInit {
  constructor(private warehouseService: WarehouseService) {}

  warehouses: Observable<Warehouse[]> = this.warehouseService.getAllList();

  filteredOptions: Observable<Observable<Warehouse[]>> = new Observable();

  value: any;

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  @Input() label = 'Склад';

  @Output() SelectWarehouse = new EventEmitter<Warehouse>();

  public displayProperty(warehouse: any) {
    if (warehouse) {
      return warehouse?.description;
    }
    return;
  }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: string | Warehouse): Observable<Warehouse[]> {
    const lowerValue =
      typeof value === 'string' ? value.toLowerCase() : value?.description.toLowerCase();

    return this.warehouses.pipe(
      map((warehouses) =>
        warehouses.filter((wh) => {
          if (!lowerValue) return true;
          return wh?.description.toLowerCase().includes(lowerValue);
        })
      )
    );
  }

  onSelect(event: MatAutocompleteSelectedEvent) {
    this.SelectWarehouse.emit(event.option.value);
  }
}
